// extracted by mini-css-extract-plugin
export default {"changePasswordBody":"ChangePasswordModal_changePasswordBody__qOeJU"};